import { useMemo } from 'react';
import { useTable, useSortBy, useFlexLayout } from 'react-table';
import { Icons } from '../icons/icons';

type Column = {
  accessor: string;
  Header: string;
  sort?: boolean;
  Cell?: any;
};

type Props = {
  isLoading?: boolean;
  columns: Column[];
  rows: { [key: string]: string | number | boolean }[];
  onUpdate?(item: any): void;
  onDelete?(item: any): void;
};

export const Table = (props: Props): JSX.Element => {
  const data = useMemo(() => props.rows, [props.rows]);
  const columns = useMemo(() => props.columns, [props.columns]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data }, useSortBy, useFlexLayout);

  return (
    <div className="new-table-wrapper">
      <div {...getTableProps()} className="new-table" style={{ maxWidth: '100%', overflowX: 'auto' }}>
        <div>
          {headerGroups.map((headerGroup) => (
            <div {...headerGroup.getHeaderGroupProps()} className="new-thead">
              {headerGroup.headers.map((column: any) => {
                const props = column.sort
                  ? column.getHeaderProps(column.getSortByToggleProps())
                  : column.getHeaderProps();
                return (
                  <div {...props} className={`header-cell new-th ${column.id === 'locked' ? 'row-status' : column.id === 'actions' ? 'new-th-action' : ''}`}>
                    {column.render('Header')}
                    {column.sort && (
                      <span className="sort-arrows">
                        {!column.isSorted ? <Icons.SortArrows /> : column.isSortedDesc ? <Icons.SortArrowUp /> : <Icons.SortArrowDown />}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div {...getTableBodyProps()}>
          {rows?.map((row) => {
            prepareRow(row);
            return (
              <div {...row.getRowProps()} className="new-row">
                {row.cells.map((cell) => {
                  if (cell.column.id === 'actions') {
                    return cell.render('Cell', { key: cell.column.id });
                  }
                  return (
                    <div {...cell.getCellProps()} className={`body-cell new-td ${cell.column.id === 'locked' ? 'row-status' : ''}`}>
                      {cell.render('Cell')}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        {props.isLoading && <div className='text-center no-data-container'>
          <div><Icons.Data /></div>
          <p className="no-data-table">Loading...</p>
        </div>}
        {!props.isLoading && !rows?.length && <div className='text-center no-data-container'>
          <div><Icons.Data /></div>
          <p className="no-data-table">No data available in table.</p>
        </div>}
      </div>
    </div>
  );
};
